import React from 'react';
import { BoundSearchQuery } from "../../../types/common/BoundSearchQuery";
import { BUYER_INTERCHANGES_DATE_BYPASS_KEYS, BuyerInventoryActivitySearchCriteria  } from "../../../types/model/criteria/inventoryActivity/BuyerInventoryActivitySearchCriteria";
import { PageableParams } from "../../../types/model/params/PageableParams";
import { optionsEndpoints } from "../../../requests/api-endpoints";
import {
  SortFilterContainer,
  SortFilterItemContainer,
  SortFilterRowContainer
} from "../../common/reports/sortFilter";
import {
  sortByFields,
  BuyerInventoryActivitySortByType,
  BuyerInventoryActivitySortParams
} from "../../../types/model/params/sortParams/BuyerInventoryActivitySortParams";
import {
  BoundSortSelect,
  BoundDataDrivenAutocomplete,
  BoundTextInput,
  BoundDateRangeFilter,
  BoundCheckBoxInput,
  BoundAssetTypeAutocomplete
} from "../../common/inputs/boundInputs";

export interface BuyerInterchangeSearchParams extends BuyerInventoryActivitySearchCriteria , BuyerInventoryActivitySortParams, PageableParams, BoundSearchQuery {}

export interface BuyerInterchangeSortFilterProps {
  query: BuyerInterchangeSearchParams;
  onChange: (newQuery: BuyerInterchangeSearchParams) => void;
}

const BuyerInterchangeSortFilter = ({
  query,
  onChange
}: BuyerInterchangeSortFilterProps) => {
  return <SortFilterContainer>
    <SortFilterRowContainer>
      <SortFilterItemContainer>
        <BoundDataDrivenAutocomplete<BuyerInterchangeSearchParams>
          label="Location"
          requestUrl={optionsEndpoints.buyer.inventoryActivity.location}
          name="locationId"
          value={query?.locationId}
          onChange={onChange}
        />
      </SortFilterItemContainer>
      <SortFilterItemContainer>
        <BoundDataDrivenAutocomplete<BuyerInterchangeSearchParams>
          label="Supplier"
          requestUrl={optionsEndpoints.buyer.inventoryActivity.supplier}
          name="supplierId"
          value={query?.supplierId}
          onChange={onChange}
        />
      </SortFilterItemContainer>
      <BoundDateRangeFilter<BuyerInterchangeSearchParams>
        query={query}
        onChange={onChange}
        dateBypassKeys={BUYER_INTERCHANGES_DATE_BYPASS_KEYS}
        idSearchLabel="booking number"
      />
    </SortFilterRowContainer>
    <SortFilterRowContainer>
      <SortFilterItemContainer>
        <BoundAssetTypeAutocomplete<BuyerInterchangeSearchParams>
          label="Equipment Type"
          name="equipmentType"
          value={query?.equipmentType}
          onChange={onChange}
        />
      </SortFilterItemContainer>
      <SortFilterItemContainer>
        <BoundTextInput<BuyerInterchangeSearchParams>
          label="Equipment Number"
          name="equipmentNumber"
          minLength={3}
          value={query?.equipmentNumber}
          onChange={onChange}
        />
      </SortFilterItemContainer>
      <SortFilterItemContainer>
        <BoundSortSelect<BuyerInterchangeSearchParams, BuyerInventoryActivitySortByType>
          query={query}
          defaultSortBy="ACTIVITY_DATE"
          defaultSortDir="desc"
          sortByFields={sortByFields}
          onChange={onChange}
        />
      </SortFilterItemContainer>
    </SortFilterRowContainer>
    <SortFilterRowContainer>
      <SortFilterItemContainer>
        <BoundTextInput<BuyerInterchangeSearchParams>
          label="Driver Name"
          name="driverName"
          minLength={3}
          value={query?.driverName}
          onChange={onChange}
        />
      </SortFilterItemContainer>      
      <SortFilterItemContainer>
        <BoundCheckBoxInput<BuyerInterchangeSearchParams>
          label="Exact Name Match"
          name="driverNameExact"
          value={query?.driverNameExact}
          onChange={onChange}
        />
      </SortFilterItemContainer>
    </SortFilterRowContainer>
  </SortFilterContainer>
}

export { BuyerInterchangeSortFilter };